import React, { useState, useMemo } from 'react'; // eslint-disable-line

/* Providers */
import { useIPFetcherProvider } from '../../Shops/shared/__providers__/IPFetcherProvider';

/* Redux */
import { useDispatch } from 'react-redux';
import { loginActions } from '../../../store/login/actions';

const EMAIL_REGEX = /^[\w+-.]+@([\w-]+\.)+[\w-]{2,4}$/; // eslint-disable-line
export const useSignUpForm = () => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [checked, setChecked] = useState<boolean>(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState<boolean>(false);
  const ipData = useIPFetcherProvider();
  const dispatcher = useDispatch();

  const isSignUpBottomDisabled: boolean = useMemo(() => {
    return !EMAIL_REGEX.test(email) || password.length < 6 || !checked;
  }, [email, password, checked]);

  const handleSignUpSubmit = (e: any) => {
    e.preventDefault();

    dispatcher(
      loginActions.signupRequestAction(
        email,
        password,
        ipData!.country,
        ipData!.currency,
      ),
    );
  };

  return {
    states: {
      email,
      setEmail,
      password,
      setPassword,
      checked,
      setChecked,
      isLoginModalOpen,
      setIsLoginModalOpen,
    },
    isSignUpBottomDisabled,
    handleSignUpSubmit,
  };
};
